import moment from 'moment';

exports.analyticsNorthStarEndpoint = (state) => {
    const start = moment.utc().subtract(60, 'days').format('YYYY-MM-DD');
    return `${state.config.apiUrl}/v1/analytics/northstar?start=${start}&reduce=true`;
};
exports.analyticsNorthStarV2Endpoint = state => `${state.config.apiUrl}/v2/analytics/northstar`;



// WEBPACK FOOTER //
// ./src/services/analytics/selectors.js